import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import FeedTroughMaintenanceManagementScreen from './screens/FeedTroughMaintenanceManagementScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <FeedTroughMaintenanceManagementScreen />,
  },
];

const FeedTroughMaintenanceManagementRouter = () => PermissionRoute(routesConfig);

export default memo(FeedTroughMaintenanceManagementRouter);
